import React from 'react';
import queryString from 'query-string';
import { LoginVerificacion, VerificacionCandidato } from '../requests/req_menu';
import { getPerfil } from "../requests/req_perfil";
import { notifica, amb } from '../requests/utils';
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
export default class Validacion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        let url = window.location.href;
        var uri = localStorage.getItem("url");
        if (url.split('?').length === 1) {
            if (uri !== null && uri !== undefined) {


                if (uri.split('?').length > 1) {

                    var key = queryString.parseUrl(uri).query;
                    var encodedString = key.vct;
                    var decodedString = atob(encodedString);

                    if (decodedString !== "{}" && decodedString !== "") {
                        var json = JSON.parse(decodedString);
                        let User = json.User;
                        let Pass = json.Pass;
                        let idCandidato = json.idCandidato;
                        var Datalogin = {
                            usuario: User.trim(),
                            pass: Pass.trim(),
                            idCandidato
                        }
                        // LoginVerificacion(Datalogin,(x)=>this.ActionResult(x));
                        VerificacionCandidato(Datalogin, (x) => this.LoginVer(Datalogin, x));
                    } else {
                        localStorage.removeItem("url");
                        var orig = window.origin + '/';
                        window.location.replace(orig);
                    }

                }

            }
            else {
                localStorage.removeItem("url");
                var orig = window.origin + '/';
                window.location.replace(orig);
            }
        }


    }

    componentDidUpdate() {

    }
    LoginVer = (indata, sendData) => {
        if (sendData.code === 0) {
            this.setState({ visible: true });
            LoginVerificacion(indata, (x) => this.ActionResult(x));
        } else {
            notifica('warning', sendData.message, '');
        }
    }
    ActionResult = (datos) => {
        if (datos.code === 0) {
            var dts = datos.data;
            if (dts.length === 1) {
                var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(dts))));
                sessionStorage.setItem(amb + '_User', bs64);
                var cv = window.location.origin + '/perfil';

                // getPerfil(p => this.asignarfoto(p));


                //this.timer=setTimeout(() =>   getPerfil(p => this.asignarfoto(p)), 3000);
                getPerfil(p => this.asignarfoto(p));

                sleep(3000).then(() => {
                    localStorage.removeItem("url");
                    window.location.href = cv;
                });



            } else {
                notifica('warning', datos.message, '');
                document.getElementById("Id_login").click();
            }
        } else {
            notifica('warning', datos.message, '');
        }
    }
    asignarfoto = (data) => {
        var Item = data.data;
        localStorage.removeItem('foto');
        localStorage.setItem('foto', Item[0].Tabla2[0].foto !== "" ? Item[0].Tabla2[0].foto : process.env.PUBLIC_URL + "/images/default-avatar.png");
    }

    render() {
        const { visible } = this.state;
        if (visible)
            return (
                <div className="ARC_Login">
                    <div className='ARC_Lgn_Frm'>
                        <div className='ARC_Lgn_Hd'>Validación de cuenta</div>
                        <div className="ARC_Lgn_dv">
                            <br />
                            <label style={{ fontWeight: 'bold' }} >¡Haz validado tu cuenta de</label>
                            <p></p>
                            <label style={{ fontWeight: 'bold' }}>Mi Reclu exitosamente!</label>
                            <p></p>
                            <center>
                                <img src={process.env.PUBLIC_URL + '/images/icon_selecteds.png'} alt=' ' />
                            </center>
                        </div>

                    </div>
                </div>
            );
        else
            return (
                <div >

                </div>
            );
    }
}